import type { BroadcastI18nKey } from './keys';

// English translations. The fallback language when a key is missing in the active language.
export const en: Record<BroadcastI18nKey, string> = {
  // Tab
  BroadcastTabCompose: 'Broadcast',
  BroadcastTabSchedule: 'Scheduled',

  // Target
  BroadcastTargetModeLabel: 'Send to',
  BroadcastTargetSelected: 'Select groups + contacts',
  BroadcastTargetAllGroups: 'All groups (exclude)',
  BroadcastTargetAllContacts: 'All contacts (exclude)',
  BroadcastTargetGroupMembers: 'All members of a group',
  BroadcastTargetAllChats: 'All chats and groups',
  BroadcastTargetPhoneNumbers: 'Phone numbers',
  BroadcastSelectedChatsLabel: 'Select chats',
  BroadcastExcludeLabel: 'Excluded chats',
  BroadcastGroupSelectLabel: 'Select group',
  BroadcastGroupSelectPlaceholder: '-- Select a group --',
  BroadcastPhoneLabel: 'Phone numbers (space / newline / comma separated, max 100)',
  BroadcastPhonePlaceholder: 'e.g. 85259845194 8613800000000',
  BroadcastPhoneHint: '{count} / {max}',
  BroadcastBadgeContact: 'Contact',
  BroadcastBadgeGroup: 'Group',

  // Content
  BroadcastContentTypeLabel: 'Message type',
  BroadcastContentText: 'Text',
  BroadcastContentMedia: 'Media',
  BroadcastContentImageText: 'Image + caption',
  BroadcastMessageLabel: 'Message',
  BroadcastMessagePlaceholder: 'Type your message...',
  BroadcastMediaLabel: 'Choose files',
  BroadcastImageTextImageLabel: 'Choose image',
  BroadcastImageTextMessageLabel: 'Caption',
  BroadcastImageTextMessagePlaceholder: 'Type the caption...',

  // Interval & schedule
  BroadcastIntervalLabel: 'Send interval (seconds)',
  BroadcastIntervalSep: '~',
  BroadcastScheduleLabel: 'Schedule for later',
  BroadcastSilentLabel: 'Send silently (no notification)',

  // Progress
  BroadcastProgressLabel: 'Progress',
  BroadcastProgressDetail: '{current} / {total} ({percent}%) - {success} ok, {fail} failed',

  // Buttons
  BroadcastBtnStart: 'Start broadcast',
  BroadcastBtnStop: 'Stop',
  BroadcastBtnClose: 'Close',
  BroadcastBtnRefresh: 'Refresh',
  BroadcastBtnCancel: 'Cancel',

  // Task list
  BroadcastTaskEmpty: 'No scheduled tasks',
  BroadcastTaskStatusPending: 'Pending',
  BroadcastTaskStatusRunning: 'Running',
  BroadcastTaskStatusCompleted: 'Completed',
  BroadcastTaskStatusCancelled: 'Cancelled',
  BroadcastTaskScheduledTime: 'Scheduled at: {time}',
  BroadcastTaskTargetWithCount: 'Target: {mode} ({count})',
  BroadcastTaskTargetNoCount: 'Target: {mode}',
  BroadcastTaskContent: 'Content: [{type}] {preview}',
  BroadcastTaskProgress: 'Progress: {current} / {total}',
  BroadcastTaskTitle: 'Task #{id}',

  // Alerts
  BroadcastAlertPickChat: 'Please select at least one chat.',
  BroadcastAlertPickGroup: 'Please select a group.',
  BroadcastAlertPickFile: 'Please choose at least one file.',
  BroadcastAlertPickImage: 'Please choose an image.',
  BroadcastAlertPickImageText: 'Please type the caption for the image.',
  BroadcastAlertPickPhone: 'Please enter at least one phone number.',
  BroadcastAlertPickMessage: 'Please type a message.',
  BroadcastAlertTimeMustFuture: 'The scheduled time must be in the future.',
  BroadcastScheduledCreated: 'Scheduled task created!\nWill send at: {time}',
  BroadcastFinishedAllFail: 'Broadcast finished: all {fail} messages failed. Check the console.',
  BroadcastFinishedPartial: 'Broadcast finished: {success} ok, {fail} failed (see console).',
  BroadcastFinishedAllOk: 'Broadcast complete! {success} message(s) sent.',

  // Top-level
  BroadcastOpenPanelTitle: 'Open broadcast panel',
  BroadcastMembersUnit: 'members',
};
